import courseRepo      from '../services/courses';
import testimonialRepo from '../services/testimonials';
import moduleRepo      from '../services/modules';
import timetables      from '../services/timetables';
import venues          from '../services/venues';
import packs           from '../services/resourcePacks';
import presenters      from '../services/presenters';
import eventRepo       from "../services/events";

export const ADMIN_COURSE_LIST_REFRESHED       = 'ADMIN_COURSE_LIST_REFRESHED';
export const ADMIN_TESTIMONIAL_LIST_REFRESHED  = 'ADMIN_TESTIMONIAL_LIST_REFRESHED';
export const ADMIN_MODULE_LIST_REFRESHED       = 'ADMIN_MODULE_LIST_REFRESHED';
export const SHOW_EDIT_COURSE_OVERLAY          = 'SHOW_EDIT_COURSE_OVERLAY';
export const SHOW_NEW_COURSE_OVERLAY           = 'SHOW_NEW_COURSE_OVERLAY';
export const HIDE_COURSE_OVERLAY               = 'HIDE_COURSE_OVERLAY';
export const SET_ELEARNING_COURSE              = 'SET_ELEARNING_COURSE';
export const SHOW_DELETE_COURSE_OVERLAY        = 'SHOW_DELETE_COURSE_OVERLAY';
export const HIDE_DELETE_COURSE_OVERLAY        = 'HIDE_DELETE_COURSE_OVERLAY';
export const SHOW_ADD_TESTIMONIAL_FORM         = 'SHOW_ADD_TESTIMONIAL_FORM';
export const HIDE_TESTIMONIAL_FORM_OVERLAY     = 'HIDE_TESTIMONIAL_FORM_OVERLAY';
export const HIDE_TESTIMONIAL_LIST_OVERLAY     = 'HIDE_TESTIMONIAL_LIST_OVERLAY';
export const SHOW_TESTIMONIAL_LIST_OVERLAY     = 'SHOW_TESTIMONIAL_LIST_OVERLAY';
export const SHOW_DELETE_TESTIMONIAL_OVERLAY   = 'SHOW_DELETE_TESTIMONIAL_OVERLAY';
export const HIDE_DELETE_TESTIMONIAL_OVERLAY   = 'HIDE_DELETE_TESTIMONIAL_OVERLAY';
export const SHOW_EDIT_TESTIMONIAL_FORM        = 'SHOW_EDIT_TESTIMONIAL_FORM';
export const CLOSE_TESTIMONIAL_FORM_OVERLAY    = 'CLOSE_TESTIMONIAL_FORM_OVERLAY';
export const CANCEL_TESTIMONIAL_FORM_OVERLAY   = 'CANCEL_TESTIMONIAL_FORM_OVERLAY';
export const COURSE_LIST_TIMETABLES_LOADED     = 'COURSE_LIST_TIMETABLES_LOADED';
export const COURSE_LIST_VENUES_LOADED         = 'COURSE_LIST_VENUES_LOADED';
export const COURSE_LIST_RESOURCE_PACKS_LOADED = 'COURSE_LIST_RESOURCE_PACKS_LOADED';
export const COURSE_LIST_PRESENTERS_LOADED     = 'COURSE_LIST_PRESENTERS_LOADED';
export const COURSE_LIST_REFRESHING            = 'COURSE_LIST_REFRESHING';
export const SORT_ELEARNING_ATTENDEES          = 'SORT_ELEARNING_ATTENDEES';
export const TOGGLE_SELECT_ALL_ELEARNING_ATTENDEES = 'TOGGLE_SELECT_ALL_ELEARNING_ATTENDEES';
export const ELEARNING_ATTENDEE_SELECT_CHANGED = 'ELEARNING_ATTENDEE_SELECT_CHANGED';
export const TOGGLE_ATTENDEE_MODULE_OVERLAY    = 'TOGGLE_ATTENDEE_MODULE_OVERLAY';
export const UPDATE_ATTENDEE_MODULES           = 'UPDATE_ATTENDEE_MODULES';
export const RESET_SELECT_ALL_ELEARNING_ATTENDEES = 'RESET_SELECT_ALL_ELEARNING_ATTENDEES';
export const SHOW_EDIT_ELEARNING_ATTENDEE_OVERLAY = 'SHOW_EDIT_ELEARNING_ATTENDEE_OVERLAY';
export const HIDE_EDIT_ELEARNING_ATTENDEE_OVERLAY = 'HIDE_EDIT_ELEARNING_ATTENDEE_OVERLAY';
export const SHOW_DELETE_ELEARNING_ATTENDEE_OVERLAY = 'SHOW_DELETE_ELEARNING_ATTENDEE_OVERLAY';
export const HIDE_DELETE_ELEARNING_ATTENDEE_OVERLAY = 'HIDE_DELETE_ELEARNING_ATTENDEE_OVERLAY';
export const SHOW_DELETE_ELEARNING_COURSE_OVERLAY = 'SHOW_DELETE_ELEARNING_COURSE_OVERLAY';
export const HIDE_DELETE_ELEARNING_COURSE_OVERLAY = 'HIDE_DELETE_ELEARNING_COURSE_OVERLAY';

export function courseListRefreshing(isRefreshing) {
    return {
        type: COURSE_LIST_REFRESHING,
        isRefreshing
    }
}

export function loadPresenters() {

    return (dispatch) => {

        function presentersLoaded(response) {

            dispatch(presentersRefreshed(response.data.data));
        }

        presenters.getAll()
            .then(presentersLoaded);
    };
}

export function presentersRefreshed(presenters) {

    return {
        type: COURSE_LIST_PRESENTERS_LOADED,
        presenters
    };
}

export function loadResourcePacks() {

    return (dispatch) => {

        function packsLoaded(response) {

            dispatch(resourcePacksRefreshed(response.data.data));
        }

        packs.getAll()
            .then(packsLoaded);
    };
}

export function resourcePacksRefreshed(packs) {

    return {
        type: COURSE_LIST_RESOURCE_PACKS_LOADED,
        packs
    };
}

export function loadVenues() {

    return (dispatch) => {

        function venuesLoaded(response) {

            dispatch(venuesRefreshed(response.data.data));
        }

        venues.getAll()
            .then(venuesLoaded);
    };
}

export function venuesRefreshed(venues) {

    return {
        type: COURSE_LIST_VENUES_LOADED,
        venues
    };
}

export function loadTimetables() {

    return (dispatch) => {

        function timetablesLoaded(response) {

            dispatch(timetablesRefreshed(response.data.data));
        }

        timetables.getAll()
            .then(timetablesLoaded);
    };
}

export function timetablesRefreshed(timetables) {

    return {
        type: COURSE_LIST_TIMETABLES_LOADED,
        timetables
    };
}

export function cancelTestimonialFormOverlay() {

    return {
        type: CANCEL_TESTIMONIAL_FORM_OVERLAY
    };
}

export function closeTestimonialFormOverlay() {

    return {
        type: CLOSE_TESTIMONIAL_FORM_OVERLAY
    };
}

export function showEditTestimonialForm(testimonial) {

    return {
        type: SHOW_EDIT_TESTIMONIAL_FORM,
        testimonial
    };
}

export function deleteTestimonial(courseId, testimonialId, isElearning = false) {

    return (dispatch) => {

        function removeSuccess() {

            dispatch(hideDeleteTestimonialOverlay());
            if(!isElearning){
                dispatch(refreshCourses());
            }else{
                dispatch(getELearning());
            }
            dispatch(loadSelectedTestimonials(courseId));
        }

        testimonialRepo.remove(testimonialId)
            .then(removeSuccess);
    };
}

export function hideDeleteTestimonialOverlay() {

    return {
        type: HIDE_DELETE_TESTIMONIAL_OVERLAY
    };
}

export function showDeleteTestimonialOverlay(testimonial) {

    return {
        type: SHOW_DELETE_TESTIMONIAL_OVERLAY,
        testimonial
    };
}

export function showTestimonialListOverlay(courseId) {

    return {
        type: SHOW_TESTIMONIAL_LIST_OVERLAY,
        courseId
    };
}

export function hideTestimonialListOverlay() {

    return {
        type: HIDE_TESTIMONIAL_LIST_OVERLAY
    };
}

export function showAddTestimonialForm() {

    return {
        type: SHOW_ADD_TESTIMONIAL_FORM
    };
}

export function hideTestimonialFormOverlay() {

    return {
        type: HIDE_TESTIMONIAL_FORM_OVERLAY
    };
}

export function deleteCourse(courseId) {

    return (dispatch) => {

        function removeSuccess() {
            
            dispatch(hideDeleteCourseOverlay());
            dispatch(refreshCourses());
        }

        courseRepo.remove(courseId)
            .then(removeSuccess);
    };
}

export function deleteElearning(courseId) {

    return (dispatch) => {

        function removeSuccess() {

            dispatch(hideDeleteCourseOverlay());
            dispatch(getELearning());
        }

        courseRepo.remove(courseId)
            .then(removeSuccess);
    };
}

export function hideDeleteCourseOverlay() {

    return {
        type: HIDE_DELETE_COURSE_OVERLAY
    };
}

export function showDeleteCourseOverlay(course) {

    return {
        type: SHOW_DELETE_COURSE_OVERLAY,
        course
    };
}

export function hideCourseOverlay() {
    
    return {
        type: HIDE_COURSE_OVERLAY
    };
}

export function showNewCourseOverlay() {

    return {
        type: SHOW_NEW_COURSE_OVERLAY
    };
}

export function setIsELearningCourse(IsELearningCourse) {

    return {
        type: SET_ELEARNING_COURSE,
        isELearningCourse: IsELearningCourse
    };
}

export function showEditCourseOverlay(course) {

    return {
        type: SHOW_EDIT_COURSE_OVERLAY,
        course
    }
}

export function testimonialsRefreshed(testimonials) {

    return {
        type: ADMIN_TESTIMONIAL_LIST_REFRESHED,
        testimonials
    };
}

export function loadSelectedTestimonials(courseId) {

    return (dispatch) => {

        function getTestimonialsSuccess(response) {

            dispatch(testimonialsRefreshed(response.data.data));
        }

        testimonialRepo.getTestimonials(courseId)
            .then(getTestimonialsSuccess);
    };
}

export function courseListRefreshed(courseList, eLearningCourseList) {

    return {
        type: ADMIN_COURSE_LIST_REFRESHED,
        courses: courseList,
        eLearningCourses: eLearningCourseList
    }
}

export function refreshCourses() {
    return (dispatch) => {
        function getCoursesSuccess(response) {
            dispatch(courseListRefreshing(false));
            dispatch(courseListRefreshed(response.data.data.courses, response.data.data.elearningcourses));
        }
        dispatch(courseListRefreshing(true));
        return courseRepo.getAdminOverview()
            .then(getCoursesSuccess);
    };
}

export function moduleListRefreshed(moduleList) {

    return {
        type: ADMIN_MODULE_LIST_REFRESHED,
        modules: moduleList
    }
}

export function refreshModules() {

    return (dispatch) => {

        function getModulesSuccess(response) {

            dispatch(moduleListRefreshed(response.data.data));
        }

        moduleRepo.getAll()
            .then(getModulesSuccess);
    };
}

export function filterCoursesByModule(moduleId) {

    return (dispatch) => {

        function getCoursesSuccess(response) {

            dispatch(courseListRefreshed(response.data.data.courses, response.data.data.elearningcourses));
        }

        courseRepo.getAdminOverview({ module_id: moduleId })
            .then(getCoursesSuccess);
    };
}

export function getELearning() {
    return dispatch => {
        function getSuccess(response){

            dispatch(courseListRefreshed(response.data.data.courses, response.data.data.elearningcourses));
        }

        courseRepo.getAdminELearning()
            .then(getSuccess);
    }
}

export function sortAttendees(courseId, attribute, direction) {

    return {
        type: SORT_ELEARNING_ATTENDEES,
        courseId,
        attribute,
        direction
    };
}

export function toggleSelectAllAttendees(courseId) {

    return {
        type: TOGGLE_SELECT_ALL_ELEARNING_ATTENDEES,
        courseId: courseId
    };
}

export function attendeeSelectionChanged(courseId, attendeeId, isSelected) {

    return {
        type: ELEARNING_ATTENDEE_SELECT_CHANGED,
        courseId,
        attendeeId,
        isSelected
    };
}

export function toggleAttendingMultipleDays(attendee) {

    return (dispatch) => {

        function updateSuccess() {

            dispatch(getELearning());
        }

        const attendeeParams = {
            ...attendee,
            attending_all_days: !attendee.attending_all_days
        };

        eventRepo.updateAttendee(attendeeParams)
            .then(updateSuccess);
    };
}

export function toggleAttendeeModuleOverlay(){
    return {
        type: TOGGLE_ATTENDEE_MODULE_OVERLAY
    }
}

export function updateAttendeeModules(modules){
    return {
        type: UPDATE_ATTENDEE_MODULES,
        modules
    }
}

export function resetSelectAllAttendees(courseId) {

    return {
        type: RESET_SELECT_ALL_ELEARNING_ATTENDEES,
        courseId: courseId
    };
}

export function showEditAttendeeOverlay(attendee) {

    return {
        type: SHOW_EDIT_ELEARNING_ATTENDEE_OVERLAY,
        attendee
    };
}

export function hideEditAttendeeOverlay(){
    return {
        type: HIDE_EDIT_ELEARNING_ATTENDEE_OVERLAY
    };
}

export function showDeleteAttendeeOverlay(attendee) {

    return {
        type: SHOW_DELETE_ELEARNING_ATTENDEE_OVERLAY,
        attendee
    };
}

export function hideDeleteAttendeeOverlay() {

    return {
        type: HIDE_DELETE_ELEARNING_ATTENDEE_OVERLAY
    }
}

export function showDeleteElearningOverlay(course) {

    return {
        type: SHOW_DELETE_ELEARNING_COURSE_OVERLAY,
        course
    }
}

export function hideDeleteElearningOverlay() {

    return {
        type: HIDE_DELETE_ELEARNING_COURSE_OVERLAY
    }
}

export function deleteAttendee(attendeeId) {

    return (dispatch) => {

        function deleteSuccess() {

            dispatch(getELearning());
            dispatch(hideDeleteAttendeeOverlay());
        }

        eventRepo.deleteAttendee(attendeeId)
            .then(deleteSuccess);
    }
}


// WEBPACK FOOTER //
// ./actions/courseList.js